@if (bannerData$ | async; as bannerData) {
  @if ({isUserLoggedIn: auth.isUserLoggedIn() | async, loginInProgress: loginInProgress }; as $) {
  @if(shouldShowLoginScreen) {
    <section class="col-md-12 p-0 login-wrapper d-flex justify-content-center align-items-center"
      >
      <cx-media [container]="bannerData?.media" class="banner-background"></cx-media>
      <div class="login-container">
        <div class="logo-section">
          <!-- <cx-page-slot position="SiteLogo"></cx-page-slot> -->
          <img src="images/Henry-login_logo.webp"/>
        </div>
        <h1 class="form-title">Sign In to your account</h1>
        <form #loginForm [attr.method]="method" [attr.action]="action" (ngSubmit)="checkIsValidUser()" [formGroup]="form">
          <input type="hidden" [attr.name]="csrf?.parameterName" [attr.value]="csrf?.token" />
          <div class="form-group">
            <span class="icon">👤</span>
            <input type="text" required autocomplete="username" class="form-control w-100" formControlName="userId" name="username"
              placeholder="{{ 'loginForm.emailAddress.placeholder' | cxTranslate }}" type="email" />
            </div>
            <cx-form-errors [control]="form.get('userId')"></cx-form-errors>
            <div class="form-group mt-3">
              <span class="icon">🔒</span>
              <input type="text" required type="text" required class="form-control w-100"
                placeholder="{{ 'loginForm.password.placeholder' | cxTranslate }}" formControlName="password" name="password"
                type="password" />
                <div class="help-text">Password is case sensitive</div>
              </div>
              <cx-form-errors [control]="form.get('password')"></cx-form-errors>
              <div class="checkbox-group">
                <input type="checkbox" id="remember" name="remember" />
                <label for="remember">Remember me</label>
              </div>
              <button type="submit" class="login-btn">
                {{ "loginForm.signIn" | cxTranslate }}
                @if (loginInProgress || $.isUserLoggedIn) {
                  <div class="custom-loader"></div>
                }
                @if (!loginInProgress && !$.isUserLoggedIn) {
                }
              </button>
              <button type="button" class="sso-btn" (click)="redirectToSSO()">
                <span>🔐</span>
                <span>{{ "loginForm.signInWithSSO" | cxTranslate }}</span>
              </button>
              <div class="access-links">
                <a routerLink="/register" id="requestAccess">Request Access</a>
              </div>
            </form>
          </div>
          <div class="footer" #copyrightPlaceholder>
          </div>
        </section>
  }
      }
    }
